import React from "react";
import * as S from "./styles";

import Logo from "../../assets/logo_black.png";

const Footer = () => {
  return (
    <S.Footer data-section="section_footer">
      <div className='container'>
        <div className='content'>
          <img
            src={Logo}
            alt='logo-footer'
            onClick={() => (window.location.href = "https://estacio.br/")}
            data-element="link_estacio"
          />
        </div>
      </div>
    </S.Footer>
  );
};

export default Footer;
